module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAARFJREFUWEftl7FNw0AYhb/XpQKJATIDG0BHxwogsQFpoAmBiibZAAlWoKKEDTIDAyDBAo+4cCSjhDvnfssp7Np377v37nzPoudHPeuz/wC2b4BRkFM/wJOk73q+pAO2HSReTzORtGgD8BbkwDFwCNxLmmUDRK3e9jtw8i+A7YrwCjgIEl5nngtwDcyDxBuZ5wJU2dwB1S5dFoI0Mm8L8CHptATgr+AAMDgwOFDkgO0H4DxxLF8lTet3Qo+h7WfgIgHwIumyK4AxcJQA+JL02QnALl/E0AgGgCAHqmZ1BtxKetzYiFb1r76Ow2/DbYtolNJ9AggvJLkOdFbJcgE6K6VZALvs9tIxyT+jUoHU+N4BfgG+4j0wak0vrgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/right-nav/id_card_a.png
// module id = 773
// module chunks = 1